import { Tabs } from "@asayinc/component-library";
import { Box } from "@mui/material";
import { Outlet, useMatch, useNavigate, useParams } from "react-router-dom";

import { BackLink } from "src/components/atoms/BackLink";
import { ErrorState } from "src/components/atoms/ErrorState";
import { PageContainer } from "src/components/containers/PageContainer/PageContainer";
import { EventPageHeader } from "src/components/molecules/EventPageHeader";
import { LoadingHeader } from "src/components/molecules/Loading/LoadingHeader";
import { ADDITIONAL_MAILING_TABS } from "src/constants/tabs";
import { useAdditionalMailingQuery } from "src/store/additionalMailing";
import { ADDITIONAL_MAILING_TYPE_LABEL } from "src/constants/labels/additionalMailingLabel";
import { AdditionalMailingType } from "src/store/additionalMailing/types";

export function AdditionalMailing() {
  const navigate = useNavigate();
  const { id } = useParams() as { id: string };
  const {
    data: additionalMailing,
    isLoading,
    error,
  } = useAdditionalMailingQuery({ id });
  const match = useMatch(`/additional-mailings/${id}/:activeTab`) as {
    params: { activeTab: string };
  };

  const handleTabChange = (value: string) => {
    navigate(`/additional-mailings/${id}/${value}`);
  };

  if (error || (!isLoading && !additionalMailing)) {
    return <ErrorState />;
  }

  const typeLabel = additionalMailing
    ? ADDITIONAL_MAILING_TYPE_LABEL[
        additionalMailing.type as AdditionalMailingType
      ] || additionalMailing.type
    : "";

  return (
    <PageContainer>
      <BackLink
        sx={{ mb: 3, ml: -2, pt: 10, px: 10 }}
        label="Additional Mailings"
        to={`/additional-mailings?view=${
          additionalMailing?.operationsStatus === "approved"
            ? "recently_approved"
            : "pending_approval"
        }`}
      />
      {isLoading ? (
        <LoadingHeader sx={{ px: 10 }} numberOfRows={1} />
      ) : (
        <EventPageHeader
          backLink={`/additional-mailings/${id}/details`}
          issuerName={additionalMailing.issuer.name || "-"}
          issuerId={additionalMailing.issuer?.id}
          type={typeLabel}
          subHeader={additionalMailing.jobNumber || ""}
          sx={{ px: 10 }}
        />
      )}
      <Box sx={{ mx: 10, mt: 3 }}>
        <Tabs
          activeTab={match?.params?.activeTab || "details"}
          clickHandler={handleTabChange}
          tabs={ADDITIONAL_MAILING_TABS}
        />
      </Box>
      <Outlet />
    </PageContainer>
  );
}
